import { render, staticRenderFns } from "./TransactionsList.vue?vue&type=template&id=cfff74e2"
import script from "./TransactionsList.vue?vue&type=script&lang=js"
export * from "./TransactionsList.vue?vue&type=script&lang=js"
import style0 from "./TransactionsList.vue?vue&type=style&index=0&id=cfff74e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports